let embedController = () => {
    require('../modules/jwplayer-embed').on();
};

export default embedController;
